import { create } from "zustand";
import { setInitialDate } from "~/utils/date";
import { Partner } from "~/types/partners";

const defaultContractSelection = {
    id: "",
    name: "",
    country: "",
    status: "",
    startDate: setInitialDate(),
    endDate: setInitialDate("plus", { years: 1 }),
    brandId: "",
    reference: "",
    externalReference: "",
    responsible: "",
    therapeuticArea: "",
    indication: "",
    comments: "",
    products: [
        {
            name: "",
        },
    ],
    additionalPartners: [
        {
            name: "",
        },
    ],
    primaryContractPartner: {} as Partner,
};

const defaultOrderSelection = {
    orderId: "",
    productName: "",
    salessystemOrderId: "",
    treatmentSite: "",
    infusionDate: setInitialDate(),
    linked: true,
    extContractRef: "",
    orderStatus: "",
    cquenceId: "",
};

const defaultOutcomeDetails = {
    infusionDate: undefined,
    variables: [],
    evidences: [] as string[],
    reason: undefined,
    attachments: [],
    notes: [],
    descriptions: [],
};

const defaultSteps = [
    {
        id: "select-contract",
        title: "Contract selection",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "select-order",
        title: "Order selection",
        description:
            "Lorem 2 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
    {
        id: "outcome-details",
        title: "Outcome details",
        description:
            "Lorem 3 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
        isCompleted: false,
    },
];

interface CreateOutcomeState {
    contractSelection: typeof defaultContractSelection;
    setContractSelection: (selection: any) => void;

    orderSelection: typeof defaultOrderSelection;
    setOrderSelection: (selection: any) => void;

    outcomeDetails: typeof defaultOutcomeDetails;
    setOutcomeDetails: (details: any) => void;

    steps: typeof defaultSteps;
    stepSetter: (steps: any) => void;

    resetOutcomeData: () => void;
}

export const useCreateOutcomeStore = create<CreateOutcomeState>(set => ({
    contractSelection: defaultContractSelection,
    setContractSelection: contractSelection => set({ contractSelection }),

    orderSelection: defaultOrderSelection,
    setOrderSelection: orderSelection => set({ orderSelection }),

    outcomeDetails: defaultOutcomeDetails,
    setOutcomeDetails: outcomeDetails => set({ outcomeDetails }),

    steps: defaultSteps,
    stepSetter: steps => set({ steps }),

    resetOutcomeData: () =>
        set({
            contractSelection: { ...defaultContractSelection },
            orderSelection: { ...defaultOrderSelection },
            outcomeDetails: { ...defaultOutcomeDetails },
            steps: [...defaultSteps],
        }),
}));
